import React from 'react';
import Link from 'components/Link';
import PropTypes from 'prop-types';
import ImageV2 from 'components_v2/common/ImageV2';
import s from './VsCard.scss';
import {
  TOI_LIVE_DOMAIN,
  TOI_LIVE_MOBILE_DOMAIN,
} from '../../../constants/index';

function VsCard({
  title,
  msid,
  isLarge,
  seopath,
  wu,
  isWapView,
  sectionName,
  index,
  lazyloadImg,
  isToiWidget,
  isShortVideo,
  ga4Type,
  gaIndex,
  src,
  target,
  width,
  imageWrapClassName,
}) {
  const ImageElement = ImageV2;
  const domain = isWapView ? 'MWEB' : 'WEB';
  const path = isWapView
    ? `${TOI_LIVE_MOBILE_DOMAIN}/${seopath}/photostory/${msid}.cms`
    : `${TOI_LIVE_DOMAIN}/${seopath}/photostory/${msid}.cms`;
  const checkHtml = /(<([^>]+)>)/i;
  const htmlStatus = title ? checkHtml.test(title) : '';
  let linkGa = `${domain}-webstory_listing-${sectionName}|click|story${index.gaindex ||
    gaIndex}/${wu || path}`;
  if (isToiWidget) {
    linkGa = `${domain}-toi_visualstories|click|story${index.gaindex ||
      gaIndex}/${wu || path}`;
  }

  return (
    <Link
      to={wu || path}
      target={`${target}`}
      className={`${s.vsCardWrap} ${isLarge ? s.isLarge : ''} ${
        isShortVideo ? s.vshortVideo : ''
      }`}
      data-ga={linkGa}
      ga4Data={
        ga4Type && [
          {
            event: 'user_click',
            type: `${ga4Type}`,
            category: 'story_click',
            story_no: `${index.gaindex || gaIndex}`,
            msid,
          },
        ]
      }
    >
      <div className={`${s.imageWrap} ${imageWrapClassName}`}>
        <ImageElement
          width={width || '600'}
          msid={msid}
          placeHolderSrc="https://static.toiimg.com/photo/87458172.cms"
          alt=""
          lazyload={lazyloadImg}
          offsetVertical={300}
          src={src}
        />
      </div>
      <i className={s.labaleIcon} />
      <div className={s.textWrap}>
        {htmlStatus ? (
          <p
            className={s.mainText}
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          />
        ) : (
          <p className={s.mainText}>{title}</p>
        )}
        {sectionName && (
          <div className={s.catText}>
            {sectionName.includes('-')
              ? sectionName.replace(/-/g, ' ')
              : sectionName}
          </div>
        )}
      </div>
    </Link>
  );
}
VsCard.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  isLable: PropTypes.bool,
  isLarge: PropTypes.string,
  isShortVideo: PropTypes.bool,
  ga4Type: PropTypes.string,
  gaIndex: PropTypes.number,
  target: PropTypes.string,
  imageWrapClassName: PropTypes.string,
};
VsCard.defaultProps = {
  isLable: false,
  isLarge: '',
  isShortVideo: false,
  ga4Type: '',
  gaIndex: '',
  target: '_blank',
  imageWrapClassName: '',
};

export default VsCard;
